import { styled } from '@mui/material'

// Items sit a hairline apart, so the selected fill of one never touches the hover fill of the next.
export const NAV_ITEM_GAP = '0.0625rem'

/**
 * A run of `NavItem`s, `NavGroup`s, `NavSection`s and `NavDivider`s, marked up as a list so screen readers
 * announce it and how many entries it holds. Each of those is its own list item.
 */
export const NavList = styled('ul')({
  display: 'flex',
  flexDirection: 'column',
  gap: NAV_ITEM_GAP,
  margin: 0,
  padding: 0,
  listStyle: 'none',
})
